import { Alert, Box, SxProps } from '@mui/material';
import { CircleAlert } from 'lucide-react';

import { Children } from '@/utils/types';

interface Props extends Children {
  sx?: SxProps;
}

export default function ErrorBanner({ children, sx }: Props) {
  return (
    <Box justifyContent="center" sx={sx}>
      <Alert
        icon={<CircleAlert className="text-foreground size-4" />}
        severity="error"
        sx={{
          color: 'error.main',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {children}
      </Alert>
    </Box>
  );
}
